import type { IOption } from '@frontend/components/interfaces';

export function getSelectArrayValueObject<T>(value: T, array: IOption<T>[]) {
    const selectedItem = array.find((item) => item.value === value);
    if (!value) {
        return;
    }

    return {
        value,
        label: selectedItem?.label,
    };
}
